var React = require('react');

function SmallDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#a0b1c4;}")),React.createElement("g",{"transform":"translate(-2.6 -4.6)","key":1},React.createElement("path",{"className":"a","d":"M8,11.4,2.6,6,4,4.6l4,4,4-4L13.4,6Z"}))]);
}

SmallDown.defaultProps = {"width":"10.8","height":"6.8","viewBox":"0 0 10.8 6.8"};

module.exports = SmallDown;

SmallDown.default = SmallDown;
